<template>
  <div>
    <!--品名维护  -->
    <baseBreadcrumb :page="$t('message.commodityMaintenance')" :menu="$t('message.operationAndMaintenance')" />
    <section>
      <div class="header">
        <div class="tabs">
          <el-tabs v-model="datas.type" type="card" @tab-click="search">
            <!-- 全部品名 -->
            <el-tab-pane :label="$t('message.fullNamePM')" name=""></el-tab-pane>
            <!-- 非标准品名 -->
            <el-tab-pane :label="$t('message.nonStandardName')" name="1"></el-tab-pane>
            <!-- 标准品名 -->
            <el-tab-pane :label="$t('message.standardGoods')" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="headerContainer">
          <div class="operationContainer">
            <div class="leftContainer">
              <div class="Container">
                <el-input v-model="datas.goods_id" placeholder="商品ID" onfocus="this.select()" clearable></el-input>
              </div>
              <!-- <div class="Container">
                <el-select v-model="datas.type">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div> -->
              <!-- 搜索 -->
              <el-button type="primary" @click="search">
                {{ $t("message.search") }}
              </el-button>
            </div>
            <div class="rightContainer">
              <!-- 选中同ID商品 -->
              <el-button @click="productWithTheSameId" type="primary" class="primary">{{
                $t("message.selectTheItemWithTheSameID") }}</el-button>
              <!-- 批量设置标准 -->
              <el-button type="primary" @click="allSetStandard" v-if="isAuth(401)">{{
                $t("message.allSetStandard")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="footerContainer">
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#EDEFF4' }"
            @selection-change="handleSelectionChange" ref="multipleTable" @cell-click="labelSelection" max-height="650">
            <el-table-column type="index" label="NO" align="center" width="50px">
            </el-table-column>
            <el-table-column type="selection" width="45" align="center">
            </el-table-column>
            <!-- 店铺 -->
            <el-table-column prop="shop_name" :label="$t('message.storeInformation')" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.shop_name }}</p>
                <p>{{ scope.row.shop_id }}</p>
              </template>
            </el-table-column>
            <!--商品图片 -->
            <el-table-column prop="name" :label="$t('message.productPicture')" align="center">
              <template slot-scope="scope">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="scope.row.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${scope.row.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="scope.row.pic" alt="" style="width: 60px; height: 60px" />
                  </a>
                </el-popover>
              </template>
            </el-table-column>
            <!-- 商品属性 -->
            <el-table-column prop="name" :label="$t('message.commodityAttribute')" align="center" width="210">
              <template slot-scope="scope">
                <p v-for="(item, index) in scope.row.detail_y" :key="index" class="detail">
                  <span :title="item.key">{{ item.key }}:</span>
                  <span class="value" :title="item.value">{{
                    item.value
                  }}</span>
                </p>
              </template>
            </el-table-column>

            <!--标准品名  -->
            <el-table-column prop="name" :label="$t('message.standardGoods')" align="center" width="210">
              <template slot-scope="scope">
                <p class="detail nation">
                  <span class="name">CN:</span><span :title="scope.row.goods_name_cn">{{
                    scope.row.goods_name_cn
                  }}</span>
                </p>
                <p class="detail nation">
                  <span class="name">Japan:</span><span :title="scope.row.goods_name_jp">{{
                    scope.row.goods_name_jp
                  }}</span>
                </p>
                <p class="detail nation">
                  <span class="name">EN:</span><span :title="scope.row.goods_name_en">{{
                    scope.row.goods_name_en
                  }}</span>
                </p>
              </template>
            </el-table-column>
            <!--标准材质  -->
            <el-table-column prop="name" :label="$t('message.standardMaterial')" align="center" width="210">
              <template slot-scope="scope">
                <p class="detail nation">
                  <span class="name">CN:</span><span :title="scope.row.goods_material_cn">{{
                    scope.row.goods_material_cn
                  }}</span>
                </p>
                <p class="detail nation">
                  <span class="name">Japan:</span><span :title="scope.row.goods_material_jp">{{
                    scope.row.goods_material_jp
                  }}</span>
                </p>
                <p class="detail nation">
                  <span class="name">EN:</span><span :title="scope.row.goods_material_en">{{
                    scope.row.goods_material_en
                  }}</span>
                </p>
              </template>
            </el-table-column>
            <!--类别  -->
            <el-table-column prop="statusName" :label="$t('message.category')" align="center" width="120">
            </el-table-column>
            <!--商品中文描述  -->
            <el-table-column prop="desc_cn" :label="$t('message.productDescriptionInChinese')" align="center" width="120">
            </el-table-column>
            <!--设置人  -->
            <el-table-column :label="$t('message.setName')" align="center">
              <template slot-scope="scope">
                <p class="detail">
                  {{ scope.row.confirm_name }}
                </p>
              </template>
            </el-table-column>
            <!--操作  -->
            <el-table-column prop="name" :label="$t('message.operation')" align="center">
              <template slot-scope="scope">
                <!-- 设置标准 -->
                <p>
                  <el-button type="primary" class="primary" size="small" @click="setStandard(scope.row)"
                    v-if="isAuth(401)">
                    {{ $t("message.setStandard") }}</el-button>
                </p>

                <p style="margin-top: 10px;">
                  <!-- 选中同ID商品 -->
                  <el-button size="small" @click="productWithTheSameId" type="primary" class="primary">{{
                    $t("message.productWithTheSameId")
                  }}</el-button>
                </p>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <!-- 分页 -->
          <div class="paginationContainer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </section>
    <!-- 标准信息设置： -->
    <el-dialog :title="isAll ? $t('message.allSetStandard') : $t('message.setStandard')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1400px" center>
      <el-table :data="skuTable" style="width: 100%" border :header-cell-style="{ background: '#F0F0F0 ' }" v-if="!isAll">
        <!-- 业务员 -->
        <el-table-column :label="$t('message.salesman')" align="center" width="100">
          <template slot-scope="scope">
            <p class="detail">
              {{ scope.row.y_id }}
            </p>
            <p class="detail">
              {{ scope.row.y_name }}
            </p>
          </template>
        </el-table-column>
        <!-- 录入时间 -->
        <el-table-column :label="$t('message.entryTime')" align="center" width="100" prop="created_at">
        </el-table-column>

        <!-- 商品中文描述）-->
        <el-table-column :label="$t('message.productDescriptionInChinese')" align="center" prop="goods_name_cn">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.desc_cn" resize="none" show-word-limit onfocus="this.select()">
            </el-input>
          </template>
        </el-table-column>
        <!-- 品名 （CN）-->
        <el-table-column :label="$t('message.material') + '(CN)'" align="center" prop="goods_name_cn">
        </el-table-column>
        <!-- 材质 -->
        <el-table-column :label="$t('message.texture') + '(CN)'" align="center" prop="goods_material_cn">
        </el-table-column>
        <!-- 品名 Japan-->
        <el-table-column :label="$t('message.material') + '(Japan)'" align="center" prop="goods_name_jp">
        </el-table-column>
        <!-- 材质 -->
        <el-table-column :label="$t('message.texture') + '(Japan)'" align="center" prop="goods_material_jp">
        </el-table-column>
        <!-- 品名 EN-->
        <el-table-column :label="$t('message.material') + '(EN)'" align="center" prop="goods_name_en">
        </el-table-column>
        <!-- 材质 -->
        <el-table-column :label="$t('message.texture') + '(EN)'" align="center" prop="goods_material_en">
        </el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('message.operation')" align="center">
          <template slot-scope="scope">
            <!--  填充到标准信息  -->
            <div class="a-flex">
              <a href="javascript:;" @click="fillItem(scope.row)">
                {{ $t("message.fllStandardInformation") }}
              </a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 标准信息 -->
      <div class="standardInformation">
        <!-- 标准信息 -->
        <h6>{{ $t("message.standardInformation") }}</h6>

        <div class="table">
          <el-table :data="standard" style="width: 100%" border
            :header-cell-style="{ background: '#B3D3E9', color: '#000' }">
            <!-- 商品中文描述）-->
            <el-table-column :label="$t('message.productDescriptionInChinese')" align="center">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.desc_cn" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
            <!-- 品名 （CN）-->
            <el-table-column :label="$t('message.material') + '(CN)'" align="center" prop="goods_name_cn">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.goods_name_cn" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
            <!-- 材质 -->
            <el-table-column :label="$t('message.texture') + '(CN)'" align="center" prop="goods_material_cn">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.goods_material_cn" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
            <!-- 品名 Japan-->
            <el-table-column :label="$t('message.material') + '(Japan)'" align="center">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.goods_name_jp" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
            <!-- 材质 -->
            <el-table-column :label="$t('message.texture') + '(Japan)'" align="center" prop="goods_material_Japan">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.goods_material_jp" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
            <!-- 品名 EN-->
            <el-table-column :label="$t('message.material') + '(EN)'" align="center" prop="goods_name_en">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.goods_name_en" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
            <!-- 材质 -->
            <el-table-column :label="$t('message.texture') + '(EN)'" align="center" prop="goods_material_en">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="scope.row.goods_material_en" resize="none" show-word-limit
                  onfocus="this.select()">
                </el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="materialSetStandard">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        page: 1,
        pageSize: 50,
        goods_id: "",
        type: 0,
      },
      total: 0,
      options: [], // 类别筛选
      certificateOptions: [
        {
          label: this.$t("message.need"),
          value: 1,
        },
        {
          label: this.$t("message.noNeed"),
          value: 0,
        },
      ], // 证书
      typeOptions: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "标准",
          value: 1,
        },
        {
          label: "非标准",
          value: 2,
        },
      ],
      tableData: [], // 列表数据
      skuTable: [], // sku列表
      standard: [], // 标准数据
      dialogVisible: false,
      ids: [], //ids
      selectList: [], // 选中的数据
      isAll: false, // 是否批量
    };
  },
  created() {
    this.materialList();
  },
  methods: {
    handleClose(done) {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    materialList() {
      this.$api.siteConfiguration.materialList(this.datas).then((res) => {
        console.log(res);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.materialList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    // 设置标准
    setStandard(item) {
      this.ids = [];
      this.ids.push(item.id);
      this.standard = [];
      this.$api.siteConfiguration
        .materialGetAdminInput({ sku_id: item.sku_id })
        .then((res) => {
          this.standard.push(item);

          this.skuTable = res.data;
          this.isAll = false;
          this.dialogVisible = true;
        });
    },
    // 填充到标准信息
    fillItem(item) {
      this.standard = [];
      let data = JSON.stringify(item);
      this.standard.push(JSON.parse(data));
      this.$forceUpdate();
    },

    // 选中项
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 批量设置标准
    allSetStandard() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.ids = [];
      this.selectList.forEach((item) => {
        this.ids.push(item.id);
      });
      this.standard[0] = this.selectList[0];
      this.dialogVisible = true;
      this.isAll = true;
    },
    // 标准信息设置：保存
    materialSetStandard() {
      let datas = this.standard[0];
      datas.ids = this.ids;
      console.log(datas);
      this.$api.siteConfiguration.materialSetStandard(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.materialList();
        this.dialogVisible = false;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.materialList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.materialList();
    },
    // 同ID选择
    productWithTheSameId() {
      let list = JSON.parse(JSON.stringify(this.selectList));
      this.$refs.multipleTable.clearSelection();
      list.forEach((item) => {
        this.tableData.forEach((items) => {
          if (item.goods_id == items.goods_id) {
            console.log(items.goods_id);
            this.$refs.multipleTable.toggleRowSelection(items);
          }
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
section {
  background-color: #f6f6f6;
  padding: 0;

  .header {
    padding: 20px;

    .headerContainer {
      .operationContainer {
        display: flex;
        width: 100%;
        margin-top: 20px;

        .leftContainer {
          width: 60%;
          display: flex;

          .Container {
            width: 240px;
            margin-right: 20px;
          }
        }

        .rightContainer {
          width: 40%;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  .footer {
    .footerContainer {
      padding: 20px;

      .pic {
        width: 60px;
        height: 60px;
      }

      .detail {
        span {
          display: inline-block;
          width: 40%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .value {
          width: 50%;
        }
      }

      .nation {
        span {
          width: 70%;
        }

        .name {
          width: 25%;
        }
      }

      .type {
        span {
          width: 50px;
        }

        .value {
          width: 100px;
        }
      }
    }
  }
}

.standardInformation {
  h6 {
    padding: 20px 0;
  }
}
</style>